import PasswordMeter from '../../generic/PasswordMeter';
import { AuthContextState } from '../context/AuthContext';

type FormPasswordStrengthMeterProps = Pick<AuthContextState, 'step' | 'hidePasswordInput' | 'passwordStrength'>

/**
 * PasswordMeter component for the auth form.
 */
const AuthFormPasswordStrengthMeter = ({
  step,
  hidePasswordInput,
  passwordStrength,
}: FormPasswordStrengthMeterProps) => {
  //  Password strength meter is never shown on the login page, or in other cases where the
  //  password input is hidden (for example if they need to login with SSO).
  if (step === 'enterEmail' || hidePasswordInput || !passwordStrength) {
    return null;
  }
  return (
    <div className="margin-bottom-lg">
      <PasswordMeter strength={passwordStrength.label} />
    </div>
  );
};


export default AuthFormPasswordStrengthMeter;
